import React from 'react';
import Layout from '../components/Layout';
import './HowItWorks.css';

const steps = [
  {
    title: 'Point',
    description: 'Point your camera at your digital monitor.',
    number: '01'
  },
  {
    title: 'Scan',
    description: 'The app automatically detects the numbers and waits for a stable reading.',
    number: '02'
  },
  {
    title: 'Log',
    description: 'Confirm the readings and save them directly to Apple Health.',
    number: '03'
  }
];

const HowItWorks = () => {
  return (
    <Layout>
      <section className="how-it-works">
        <h2>How It Works</h2>
        <p>Three simple steps to log your blood pressure readings</p>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div className="step" key={index}>
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default HowItWorks;